import { Box, Stack } from "@origin-digital/ods-core";
import React from "react";
import AccordionItem from "src/components/Form/AccordionItem";
import { IFormFunctionProps } from "src/components/Form/FormAccordionContainer";
import styled from "styled-components";

const AccordionOuterBox = styled(Box)({
  paddingTop: "0px !important",
});

export const ContentSection: React.FC<IFormFunctionProps> = (
  props: IFormFunctionProps
) => {
  return (
    <AccordionOuterBox padding="none">
      <Stack space="small">
        <AccordionItem {...props} />
      </Stack>
      <div ref={props.closeTransferBlockRef} />
    </AccordionOuterBox>
  );
};
